var importGoogleType = null;
export var geolocationParser = function (googleResult) {
    return {
        display_name: googleResult.formatted_address,
        lat: googleResult.geometry.location.lat(),
        lng: googleResult.geometry.location.lng(),
        addressLine1: googleResult.address_components
            .filter(function (component) {
            return component.types.includes("street_number") ||
                component.types.includes("route");
        })
            .sort(function (component) { return (component.types.includes("route") ? -1 : 1); })
            .map(function (component) { return component.long_name; })
            .join(" "),
        locality: googleResult.address_components
            .filter(function (component) { return component.types.includes("locality"); })
            .map(function (component) { return component.long_name; })
            .join(""),
        postcode: googleResult.address_components
            .filter(function (component) { return component.types.includes("postal_code"); })
            .map(function (component) { return component.long_name; })
            .join("")
    };
};
